import { Box, Skeleton, Stack } from '@chakra-ui/react';

export function TaskLoadingSkeleton() {
  return (
    <Box p={6}>
      <Skeleton height="32px" width="200px" mb={6} />
      <Stack spacing={3}>
        <Skeleton height="24px" width="150px" />
        <Skeleton height="48px" />
        <Skeleton height="48px" />
        <Skeleton height="48px" />
      </Stack>
    </Box>
  );
}
